import React, { Component } from 'react';
import $ from 'jquery';
import '../../../css/responsive.css';

class ReabsResumeComponent extends Component {

    togglePopup = (type) => {
        const { showAlert } = this.props
        let msg = null
        let timeOut = 10000
        switch (type) {
            default:
                break;
        }
        // if (msg) {
        //     showAlert({ type: 'warning', message: msg, timeOut: timeOut });
        // }
    };

    onChangeDateFrom = (e) => {
        const { props } = this.props
        const { searchData, refreshSearch } = props;
        searchData.dateFrom = e.target.value || null;
        refreshSearch(searchData);
    };
    onChangeDateTo = (e) => {
        const { props } = this.props
        const { searchData, refreshSearch } = props;
        searchData.dateTo = e.target.value || null;
        refreshSearch(searchData);
    };
    render() {
        const { props } = this.props
        const { search, searchData } = props
        return (
            <div className="reabs-resume-filters">
                <div className="filter-group form-group d-flex align-items-center mb-2 mr-3">
                    <label className="mb-0 mr-2">
                        <strong>Desde:</strong>
                    </label>
                    <input
                        type="date"
                        className="form-control"
                        style={{
                            height: 44,
                            borderRadius: 12,
                            backgroundColor: '#f9fafb',
                            width: 180
                        }}
                        value={searchData?.dateFrom || ''}
                        onChange={this.onChangeDateFrom}
                    />
                </div>

                <div className="filter-group form-group d-flex align-items-center mb-2 mr-3">
                    <label className="mb-0 mr-2">
                        <strong>Hasta:</strong>
                    </label>
                    <input
                        type="date"
                        className="form-control"
                        style={{
                            height: 44,
                            borderRadius: 12,
                            backgroundColor: '#f9fafb',
                            width: 180
                        }}
                        value={searchData?.dateTo || ''}
                        onChange={this.onChangeDateTo}
                    />
                </div>
                <div className="mr-3 mb-2">
                    <button className="btn btn-active" data-toggle="tooltip" data-placement="top"
                        title={'Buscar'}
                        onClick={search}>
                        <i className="fas fa-search"></i>
                    </button>
                </div>
            </div>
        );
    }
}

export default ReabsResumeComponent;
